import styled from 'styled-components'

import { SpaceStyled } from '@ui/elements/Space/styles/SpaceStyled'

export const FileViewerFileListStyled = styled.div`
  overflow-x: auto;

  padding: ${(props) => props.theme.typography.pxToRem(3)};

  ${SpaceStyled} {
    width: auto;
    min-width: 100%;
  }
`
